/*
 * The navigation logic, outside the component that uses it.
 *
 * It lives in a file of its own because `react-refresh/only-export-components` forbids a
 * module from exporting a component and anything else: `layout.tsx` exports `Layout`, so
 * this function cannot live there. The constraint lands well — it is pure logic, and here it
 * is tested without mounting the shell.
 */

/**
 * Whether the menu item covers the current path.
 *
 * An exact comparison is not enough: `/clubs/new` and `/clubs/7` are inside the
 * clubs section, and with `===` the item would lose `aria-current` precisely while the
 * user is in it. `aria-current` is an accessibility claim, not a colour, so the comparison is
 * on the prefix.
 *
 * The home is handled separately: its path is a prefix of every other, and on a prefix
 * comparison it would always come out active.
 */
export function isNavItemActive(itemPath: string, currentPath: string): boolean {
  if (itemPath === '/') return currentPath === '/'
  return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`)
}
